// useBerryCrateTares — per-crate tare (kg) for the two berry crate types,
// resolved from bin_types. This is the SAME source and query Precool's
// cooling-batch weigh uses (see Precool.tsx), so the tare deducted when weighing
// crates at RECEIVING matches the tare deducted later at the cooling batch —
// the two stages never disagree about how heavy an empty crate is.
//
// Returns a map keyed by container_type code (BLUEBERRY_CRATE / STRAWBERRY_CRATE).
// A code with no configured tare is absent from the map; the caller supplies the
// PLACEHOLDER_CRATE_TARE_KG fallback + the "confirm the real tare" guard.

import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useBerryCrateTares() {
  return useQuery({
    queryKey: ['berry-crate-tares'],
    staleTime: 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('bin_types')
        .select('code, tare_kg')
        .in('code', ['BLUEBERRY_CRATE', 'STRAWBERRY_CRATE'])
      if (error) throw error
      const m: Record<string, number> = {}
      for (const r of (data ?? []) as { code: string; tare_kg: number }[]) m[r.code] = Number(r.tare_kg)
      return m
    },
  })
}
